module.exports = __webpack_public_path__ + "img/3.e37118cb.jpg";